import React, { useEffect, useRef, useState } from 'react';
import './Usermodule.css';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { RadioButton } from "primereact/radiobutton";
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, } from 'primereact/confirmdialog';
import { Checkbox } from "primereact/checkbox";

import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Api } from '../../../services/api';
import { FaTrash } from 'react-icons/fa';
import { BiPlusMedical } from 'react-icons/bi';
import { IoEye } from 'react-icons/io5';

import { useNavigate } from 'react-router-dom';

const Usermodule = () => {
  const navigate = useNavigate();

  const [isAdmin, setIsAdmin] = useState('Y');
  const [showAcess, setShowAcess] = useState('N');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [projectType, setProjectType] = useState([]);
  const [searchProjectType, setSearchProjectType] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const toast = useRef(null);
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
    useState(false);

  //* -------------------------------------------------------------
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState(null);
  //! -------------------------------------------------------------

  // -------------------------------------------------------------
  const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);
  // -------------------------------------------------------------

  const formik = useFormik({
    initialValues: {
      name: '',
      status: 'Y',
      isAdmin: 'N'

    },

    validate: (data) => {
      let errors = {};

      if (!data.name) {
        errors.name = 'First Name is required.';
      }

      return errors;
    },

    onSubmit: (data) => {

      console.log(data.name)
      var _body = {
        name: data.name,
        status: data.status,
        isAdmin: data.isAdmin,
        permission_role: ingredients,
      }


      var url = Api.API_BASE_URL + 'add-role';
      if (type == "Edit") {
        url = Api.API_BASE_URL + 'update-role/' + projectTypeID;
      }

      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        ...Api.headers,
        'Authorization': token ? `Bearer ${token}` : ''
      };

      fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(_body),
      })
        .then((response) => response.json())
        .then((Josn) => {
          if (Josn.error != '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

          } else {
            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
            closeModal();
            getProjectType();
          }

        })
        .catch((error) => {
          console.error("Error:", error);
        });


    }
  });
  // -------------------------------------------------------------
  const [ingredients, setIngredients] = useState([]);
  // -------------------------------------------------------------

  // _______________________________________________________

  const [type, setType] = useState('Add');
  const [title, setTitle] = useState('Add Project Type');
  const [projectTypeID, setProjectTypeID] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [globalFilter, setGlobalFilter] = useState('');
  // const [globalFilter, setGlobalFilter] = useState(null);


  const openModal = () => {
    setProjectTypeID('');
    formik.resetForm();
    setType('Add');
    setTitle('Add Project Role');
    setIngredients([]);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsDeleteConfirmationModalOpen(false);
  };

  const editModal = (row) => {
    setProjectTypeID(row._id);
    formik.setFieldValue('name', row.name);
    setShowAcess(row.isAdmin)

    formik.setFieldValue('status', row.status);
    formik.setFieldValue('isAdmin', row.isAdmin);
    var t = row.permission_role.split(" ");


    setIngredients(t);

    setType('Edit');
    setTitle('Edit Project Rle');
    setIsModalOpen(true);
  };



  useEffect(() => {
    console.log('Fetching projects...xx');
    getProjectType();
    // console.log(getProjectType());
  }, []);


  const getProjectType = (project) => {
    const token = localStorage.getItem('authToken');
    // console.log("Retrieved token:", token); 

    if (!token) {
      console.error("No token found");
      return; // Exit if no token is found
    }

    axios.get(Api.API_BASE_URL + 'get-all-role', {
      headers: {
        ...Api.headers,
        'Authorization': `Bearer ${token}` // Ensure token is included in the headers
      },
    })
      .then((response) => {
        var data = response.data.result;



        data.forEach((item, index) => {
          console.log(`isAdmin:`, item.isAdmin);
        });

        setProjectType(data);
        setSearchProjectType(data);
        setIsLoading(false);

      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
        setIsLoading(false);
      });
  };


  const actionBodyTemplate = (rowData) => {
    console.log('----rowData-->', rowData)
    var isDisabled = false;
    // if (rowData.isAdmin == 'Y') {
    //   isDisabled = true;
    // }
    if (rowData.oldId == 1 || rowData.oldId == 2 || rowData.oldId == 3 || rowData.oldId == 12 || rowData.oldId == 13) {
      isDisabled = true;
    }
    return (
      <React.Fragment>

        <div onClick={(e) => e.stopPropagation()}>
          <FaTrash onClick={isDisabled ? null : () => handleDeleteProject(rowData._id)} style={{ color: isDisabled ? 'lightgray' : 'darkred', pointerEvents: isDisabled ? 'none' : 'auto' }} />

          {/* <IoEye size={18} style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => {
            setSelectedProjectDetails(rowData);
            setIsDetailsModalOpen(true);
          }} /> */}

          <IoEye size={18} style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => {
            navigate(`/role-details/${rowData._id}`);
          }} />
        </div>

      </React.Fragment>
    );
  };

  const handleDeleteProject = (projectId,) => {
    setProjectTypeID(projectId);
    setIsDeleteConfirmationModalOpen(true);
  };


  const confirmDelete = async () => {
    // Retrieve the token from localStorage
    const token = localStorage.getItem('authToken');


    // Check if token exists
    if (!token) {
      console.error('No token found in localStorage');
      return;
    }

    // Make the GET request with token in the Authorization header
    try {
      const response = await axios.get(Api.API_BASE_URL + 'delete-role/' + projectTypeID, {
        headers: {
          'Authorization': `Bearer ${token}` // Set the Authorization header
        }
      });

      toast.current.show({
        severity: 'info',
        summary: 'Confirmed',
        detail: response.data.result,
        life: 3000
      });

      getProjectType();
      closeModal();
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };


  const showColor = (status) => {

    return (status == "Y") ? "Active" : "In-Active";
  }

  const searchrole = (searchValue) => {
    console.log('searchValue', searchValue);

    setProjectType([]);
    const searchResult = searchProjectType.filter((item) =>
      item.name.toLowerCase().includes(searchValue.toLowerCase())
    );
    setProjectType(searchResult);
    console.log(searchResult)
  }


  const header = (
    <div className="flex flex-wrap  align-items-center justify-content-between m-0 ">
      <span className="m-0 px-2 table-header">Manage Project Role</span>
      <div>
        <span className="p-input-icon-left ">
          <InputText className="input-field m-1" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search..." />
        </span>
        <button type="button" title='Add a new Project Role' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
          <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
            <BiPlusMedical size={14} />
            <span> ADD </span>
          </div>
        </button>
      </div>
    </div>
  );

  const onIngredientsChange = (e) => {
    let _ingredients = [...ingredients];

    if (e.checked)
      _ingredients.push(e.value);
    else
      _ingredients.splice(_ingredients.indexOf(e.value), 1);

    setIngredients(_ingredients);
  }

  const onRowSelect = (e) => {
    const rowData = e.data;
    editModal(rowData);
  };


  return (
    <>

      <div className="pagee-container mt-2">
        <Toast ref={toast} />
        <ConfirmDialog />
        <div className="pagination-datable-height">
          {isLoading ? (
            <div className="loading-spinner">
              Loading...
              <div className="spinner"></div>
            </div>
          ) : (
            <DataTable
              value={projectType}
              paginator rows={14}
              dataKey="_id"
              selection={selectedProduct}
              onRowSelect={(e) => onRowSelect(e)}
              onSelectionChange={(e) => setSelectedProduct(e.value)}
              tableStyle={{ minWidth: '50rem' }} selectionMode="single" header={header} globalFilter={globalFilter} >

              <Column body={actionBodyTemplate} header="Action" style={{ textAlign: 'center', width: '100px' }} exportable={false}></Column>
              <Column field="name" header="Role" ></Column>

              <Column field="status" header="Status" style={{ textAlign: 'center' }} body={(e) => showColor(e.status)}></Column>
            </DataTable>
          )}
        </div>
      </div>

      {/* ---------------------------------------------------------------*/}
      <Dialog header="" bodyClassName="dialog-body" visible={isModalOpen} maximizable style={{ width: '40vw' }} dismissableMask="true" onHide={() => { setIsModalOpen(false); setSelectedProduct(null); }}>
        <div className='p-4 overflow-hidden '>
          <form onSubmit={formik.handleSubmit} className="" >
            <div className="formgrid grid">

              <div className="col-4 flex-col">
                <h4 className='card-heading'>Role</h4>
                <div className='pt-2'>
                  <InputText id="name" name="name" value={formik.values.name} onChange={(e) => {
                    console.log(e.target.value);
                    formik.setFieldValue('name', e.target.value);
                  }}
                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('name') })} style={{ width: '80%' }}
                  />
                </div>

              </div>

              <div className="col-4 pt-2">
                <h4 className='card-heading'>Status</h4>
                <div className='pt-2'>
                  <RadioButton inputId="ingredient1" name="status" value="Y" onChange={(e) => formik.setFieldValue('status', e.target.value)} checked={formik.values.status === 'Y'} />
                  <label htmlFor="ingredient1" className="ml-2">Active</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <RadioButton inputId="ingredient2" name="status" value="N" onChange={(e) => formik.setFieldValue('status', e.target.value)} checked={formik.values.status === 'N'} />
                  <label htmlFor="ingredient2" className="ml-2">In-Active</label>
                </div>
              </div>

              <div className="col-4 pt-2">
                <h4 className='card-heading'>Set as Admin</h4>
                <div className='pt-2'>
                  <RadioButton inputId="ingredient1" name="isAdmin" value="Y" onChange={(e) => formik.setFieldValue('isAdmin', e.target.value)} checked={formik.values.isAdmin === 'Y'} />
                  <label htmlFor="ingredient1" className="ml-2">Yes</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <RadioButton inputId="ingredient2" name="isAdmin" value="N" onChange={(e) => formik.setFieldValue('isAdmin', e.target.value)} checked={formik.values.isAdmin === 'N'} />
                  <label htmlFor="ingredient2" className="ml-2">No</label>
                </div>
              </div>

              {/* //*-----------Access---------------------- */}
              {showAcess === 'N' && (
                <>
                  <div className="col-12 p-2 pt-4" style={{ borderBottom: '1px solid black' }}>
                    <h3 className="text-gray-800">Access</h3>
                  </div>

                  {/* //*----------- Dashboard ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Dashboard</h4>
                    <div className="module-card">
                      <div className=" align-items-center">
                        <Checkbox inputId="default_dashbord" name="permission_role" value="default_dashbord" onChange={onIngredientsChange} checked={ingredients.includes('default_dashbord')} />
                        <label htmlFor="default_dashbord" className="ml-2">Dashbord</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- Dashboard ---------- */}

                  {/* //*----------- Strategic Plan ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Strategic Plan</h4>
                    <div className="module-card">

                      <div className=" align-items-center">
                        <Checkbox inputId="business_core" name="permission_role" value="business_core" onChange={onIngredientsChange} checked={ingredients.includes('business_core')} />
                        <label htmlFor="business_core" className="ml-2 ">Business Core</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="accountability_chart" name="permission_role" value="accountability_chart" onChange={onIngredientsChange} checked={ingredients.includes('accountability_chart')} />
                        <label htmlFor="accountability_chart" className="ml-2">Organisational Chart</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="esr_dashboard" name="permission_role" value="esr_dashboard" onChange={onIngredientsChange} checked={ingredients.includes('esr_dashboard')} />
                        <label htmlFor="esr_dashboard" className="ml-2">ESR Dashboard</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- Strategic Plan ---------- */}

                  {/* //*----------- CRM ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Sales & Marketing</h4>
                    <div className="module-card">

                      <div className=" align-items-center">
                        <Checkbox inputId="lead_tracker_Dashbord" name="permission_role" value="lead_tracker_Dashbord" onChange={onIngredientsChange} checked={ingredients.includes('lead_tracker_Dashbord')} />
                        <label htmlFor="lead_tracker_Dashbord" className="ml-2 ">Dashbord</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="lead_tracker_MarketingandSales" name="permission_role" value="lead_tracker_MarketingandSales" onChange={onIngredientsChange} checked={ingredients.includes('lead_tracker_MarketingandSales')} />
                        <label htmlFor="lead_tracker_MarketingandSales" className="ml-2">Marketing</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="lead_tracker_LeadsAll" name="permission_role" value="lead_tracker_LeadsAll" onChange={onIngredientsChange} checked={ingredients.includes('lead_tracker_LeadsAll')} />
                        <label htmlFor="lead_tracker_LeadsAll" className="ml-2">CRM</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- CRM ---------- */}


                  {/* //*----------- Production ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Construction Operations</h4>
                    <div className="module-card">

                      <div className=" align-items-center ">
                        <Checkbox inputId="Production_Dashbord" name="permission_role" value="Production_Dashbord" onChange={onIngredientsChange} checked={ingredients.includes('Production_Dashbord')} />
                        <label htmlFor="Production_Dashbord" className="ml-2">Production Schedule</label>
                      </div>
                      <div className="pt-2 align-items-center ">
                        <Checkbox inputId="Completed_Jobs" name="permission_role" value="Completed_Jobs" onChange={onIngredientsChange} checked={ingredients.includes('Completed_Jobs')} />
                        <label htmlFor="Completed_Jobs" className="ml-2">Completed Jobs</label>
                      </div>
                      <div className="pt-2 align-items-center ">
                        <Checkbox inputId="Projects_Archived" name="permission_role" value="Projects_Archived" onChange={onIngredientsChange} checked={ingredients.includes('Projects_Archived')} />
                        <label htmlFor="Projects_Archived" className="ml-2">Projects Archived</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- Production ---------- */}

                  {/* //*----------- My Playbooks ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>My Playbooks</h4>
                    <div className="module-card">
                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="ProjectManager_Dashbord" name="permission_role" value="ProjectManager_Dashbord" onChange={onIngredientsChange} checked={ingredients.includes('ProjectManager_Dashbord')} />
                        <label htmlFor="ProjectManager_Dashbord" className="ml-2">Playbooks</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="ProjectManager_History" name="permission_role" value="ProjectManager_History" onChange={onIngredientsChange} checked={ingredients.includes('ProjectManager_History')} />
                        <label htmlFor="ProjectManager_History" className="ml-2">Archive History</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- My Playbooks ---------- */}

                  {/* //*----------- Performance Huddle ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Performance Huddle</h4>
                    <div className="module-card">

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="performance_huddle_dashboard" name="permission_role" value="performance_huddle_dashboard" onChange={onIngredientsChange} checked={ingredients.includes('performance_huddle_dashboard')} />
                        <label htmlFor="performance_huddle_dashboard" className="ml-2">All Performance Huddle</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="ProjectManager_PerformancePoint" name="permission_role" value="ProjectManager_PerformancePoint" onChange={onIngredientsChange} checked={ingredients.includes('ProjectManager_PerformancePoint')} />
                        <label htmlFor="ProjectManager_PerformancePoint" className="ml-2">My Performance Huddle</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- Performance Huddle ---------- */}

                  {/* //*----------- Financials ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Financials</h4>
                    <div className="module-card">

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Cashflow_PandLSummary" name="permission_role" value="Cashflow_PandLSummary" onChange={onIngredientsChange} checked={ingredients.includes('Cashflow_PandLSummary')} />
                        <label htmlFor="Cashflow_PandLSummary" className="ml-2">Financial Summary</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Cashflow_PandLandCashflowProjection" name="permission_role" value="Cashflow_PandLandCashflowProjection" onChange={onIngredientsChange} checked={ingredients.includes('Cashflow_PandLandCashflowProjection')} />
                        <label htmlFor="Cashflow_PandLandCashflowProjection" className="ml-2">Income Statement</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Cashflow_Cashflow" name="permission_role" value="Cashflow_Cashflow" onChange={onIngredientsChange} checked={ingredients.includes('Cashflow_Cashflow')} />
                        <label htmlFor="Cashflow_Cashflow" className="ml-2">Cashflow Projections</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="cost_per_sf" name="permission_role" value="cost_per_sf" onChange={onIngredientsChange} checked={ingredients.includes('cost_per_sf')} />
                        <label htmlFor="cost_per_sf" className="ml-2">Cost Per SF </label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="labour_framing_calculator" name="permission_role" value="labour_framing_calculator" onChange={onIngredientsChange} checked={ingredients.includes('labour_framing_calculator')} />
                        <label htmlFor="labour_framing_calculator" className="ml-2">Labour Framing Calculator</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- Financials ---------- */}

                  {/* //*----------- Billable vs Unbillable ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Billable vs Unbillable</h4>
                    <div className="module-card">
                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="BillablevsUnbillable_Dashbord" name="permission_role" value="BillablevsUnbillable_Dashbord" onChange={onIngredientsChange} checked={ingredients.includes('BillablevsUnbillable_Dashbord')} />
                        <label htmlFor="BillablevsUnbillable_Dashbord" className="ml-2">Pay Periods</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="BillablevsUnbillable_Year" name="permission_role" value="BillablevsUnbillable_Year" onChange={onIngredientsChange} checked={ingredients.includes('BillablevsUnbillable_Year')} />
                        <label htmlFor="BillablevsUnbillable_Year" className="ml-2">{"Year " + new Date().getFullYear()}</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="BillablevsUnbillable_Config" name="permission_role" value="BillablevsUnbillable_Config" onChange={onIngredientsChange} checked={ingredients.includes('BillablevsUnbillable_Config')} />
                        <label htmlFor="BillablevsUnbillable_Config" className="ml-2">Config</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- Billable vs Unbillable ---------- */}

                  {/* //*----------- Project Creep ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Project Slippage</h4>
                    <div className="module-card">
                      <div className="pt-2 align-items-center ">
                        <Checkbox inputId="pre_con_creep" name="permission_role" value="pre_con_creep" onChange={onIngredientsChange} checked={ingredients.includes('pre_con_creep')} />
                        <label htmlFor="pre_con_creep" className="ml-2">Pre Con Slippage</label>
                      </div>

                      <div className="pt-2 align-items-center ">
                        <Checkbox inputId="construction_creep" name="permission_role" value="construction_creep" onChange={onIngredientsChange} checked={ingredients.includes('construction_creep')} />
                        <label htmlFor="construction_creep" className="ml-2">Construction Slippage</label>
                      </div>

                      <div className="pt-2 align-items-center ">
                        <Checkbox inputId="overall_creep" name="permission_role" value="overall_creep" onChange={onIngredientsChange} checked={ingredients.includes('overall_creep')} />
                        <label htmlFor="overall_creep" className="ml-2">Over All Slippage</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- Project Creep ---------- */}

                  {/* //*----------- Upload ---------- */}
                  {/* <div className="col-6 p-2" >
                    <h4 className='card-heading'>Upload</h4>
                    <div className="module-card">
                      <div className=" align-items-center">
                        <Checkbox inputId="Upload_PandlByJob" name="permission_role" value="Upload_PandlByJob" onChange={onIngredientsChange} checked={ingredients.includes('Upload_PandlByJob')} />
                        <label htmlFor="Upload_PandlByJob" className="ml-2">P&L By Job</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Setting_Cashflow" name="permission_role" value="Setting_Cashflow" onChange={onIngredientsChange} checked={ingredients.includes('Setting_Cashflow')} />
                        <label htmlFor="Setting_Cashflow" className="ml-2">Config</label>
                      </div>

                    </div>
                  </div> */}
                  {/* //!----------- Upload ---------- */}

                  {/* //*-----------  Huddle Conversation ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'> Huddle Conversation</h4>
                    <div className="module-card">

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="quarterly_huddle_conversation" name="permission_role" value="quarterly_huddle_conversation" onChange={onIngredientsChange} checked={ingredients.includes('quarterly_huddle_conversation')} />
                        <label htmlFor="quarterly_huddle_conversation" className="ml-2">Quarterly Huddle Conversation </label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="quarterly_huddle_conversation_history" name="permission_role" value="quarterly_huddle_conversation_history" onChange={onIngredientsChange} checked={ingredients.includes('quarterly_huddle_conversation_history')} />
                        <label htmlFor="quarterly_huddle_conversation_history" className="ml-2">Quarterly Huddle Conversation History</label>
                      </div>

                    </div>
                  </div>
                  {/* //!-----------  Huddle Conversation ---------- */}

                  {/* //*----------- Quarterly Huddle Conversation ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Annual Performance Review</h4>
                    <div className="module-card">

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="performance_review" name="permission_role" value="performance_review" onChange={onIngredientsChange} checked={ingredients.includes('performance_review')} />
                        <label htmlFor="performance_review" className="ml-2">My Performance Review</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="performance_review_history" name="permission_role" value="performance_review_history" onChange={onIngredientsChange} checked={ingredients.includes('performance_review_history')} />
                        <label htmlFor="performance_review_history" className="ml-2">Performance Review History</label>
                      </div>
                    </div>
                  </div>
                  {/* //!----------- Quarterly Huddle Conversation ---------- */}

                  {/* //*----------- Setting ---------- */}
                  <div className="col-6 p-2" >
                    <h4 className='card-heading'>Setting</h4>
                    <div className="module-card">

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Setting_ProjectManager" name="permission_role" value="Setting_ProjectManager" onChange={onIngredientsChange} checked={ingredients.includes('Setting_ProjectManager')} />
                        <label htmlFor="Setting_ProjectManager" className="ml-2">Manage Role</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Setting_UserRole" name="permission_role" value="Setting_UserRole" onChange={onIngredientsChange} checked={ingredients.includes('Setting_UserRole')} />
                        <label htmlFor="Setting_UserRole" className="ml-2">Manage Users</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Setting_organization" name="permission_role" value="Setting_organization" onChange={onIngredientsChange} checked={ingredients.includes('Setting_organization')} />
                        <label htmlFor="Setting_organization" className="ml-2">Manage Organization</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Setting_LeadSourceConfig" name="permission_role" value="Setting_LeadSourceConfig" onChange={onIngredientsChange} checked={ingredients.includes('Setting_LeadSourceConfig')} />
                        <label htmlFor="Setting_LeadSourceConfig" className="ml-2">Lead Source Config</label>
                      </div>
                      
                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Setting_Cashflow" name="permission_role" value="Setting_Cashflow" onChange={onIngredientsChange} checked={ingredients.includes('Setting_Cashflow')} />
                        <label htmlFor="Setting_Cashflow" className="ml-2">Config</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Upload_PandlByJob" name="permission_role" value="Upload_PandlByJob" onChange={onIngredientsChange} checked={ingredients.includes('Upload_PandlByJob')} />
                        <label htmlFor="Upload_PandlByJob" className="ml-2">Actual</label>
                      </div>

                      <div className="pt-2 align-items-center">
                        <Checkbox inputId="Setting_Log" name="permission_role" value="Setting_Log" onChange={onIngredientsChange} checked={ingredients.includes('Setting_Log')} />
                        <label htmlFor="Setting_Log" className="ml-2">Log</label>
                      </div>

                    </div>
                  </div>
                  {/* //!----------- Setting ---------- */}
                </>
              )}
            </div>
            <div className="flex flex-wrap justify-content-center mt-5">
              <Button label="Submit" type="submit" className='p-2 customSave-button' />
            </div>
          </form>

        </div>
      </Dialog>

      {/* ---------------------------------------------------- */}
      <Dialog header="Project Role Details" visible={isDetailsModalOpen} style={{ width: '30vw' }} onHide={() => setIsDetailsModalOpen(false)}>
        {selectedProjectDetails && (
          <div>
            <h5>Role: {selectedProjectDetails.name}</h5>
            <p>Status: {showColor(selectedProjectDetails.status)}</p>
            <p>Permissions:</p>
            <ul>
              {selectedProjectDetails.permission_role.split(" ").map((permission, index) => (
                <li key={index}>{permission}</li>
              ))}
            </ul>
          </div>
        )}
      </Dialog>
      {/* ---------------------------------------------------- */}



      {/* //*------------------ DeleteConfirmation --------------------------*/}
      {isDeleteConfirmationModalOpen && (
        <div className="modal">
          <div className="small-modal-content">
            <div className="modal-headerx">
              <h5 className="modal-title">Delete Confirmation</h5>
              <button className="modal-closex" onClick={closeModal}>
                &times;
              </button>
            </div>
            <div className="modal-bodyx">
              <p>"Are you sure you want to delete this project? "</p>
            </div>
            <div className="modal-footer-cancelx">
              <button className="cancel-buttonx" onClick={closeModal}>
                Cancel
              </button>
              <button className="delete-buttonx" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {/* //!------------------ DeleteConfirmation --------------------------*/}

    </>
  )
}

export default Usermodule